import axios from "axios";

export const forceCompletePickupRequest = (
  requestNumber: string
): Promise<void> =>
  axios
    .post(`pickupRequests/${requestNumber}/forceComplete`)
    .then(() => undefined);

export default forceCompletePickupRequest;
